<template>
	<div>
        <vue-headful :title="dashboard.dashboard_name+' [Dashboard] :: MeritEHS'" />

	    <h4 class="mt-2 mb-4">
	    	<ol class="breadcrumb font-weight-bold m-0">
	    		<li class="breadcrumb-item font-weight-light d-block d-md-inline-block">
                    <router-link :to="`/`">
                        <i class="fa fa-dashboard"></i> Dashboard
                    </router-link>
                </li>
                <li class="breadcrumb-item font-weight-light d-block d-md-inline-block">
                    <router-link :to="`/dashboards/settings`">
                        Settings
                    </router-link>
                </li>
                <li class="breadcrumb-item active d-block d-md-inline-block mt-md-0 mt-2">
                    {{ dashboard.dashboard_name }}
                </li>
	    	</ol>
	    </h4>

        <div class="row mb-4">
            <div class="col-lg-6 col-md-8">
                <div class="card">
                    <div class="card-header">
                        Dashboard: {{ dashboard.dashboard_name }}

                        <div class="pull-right">
                            <router-link :to="`/dashboards/settings/edit/${dashboard.id}`"
                                class="btn btn-sm btn-default"
                                v-if="$store.state.user.is_admin || $store.state.user.user_id == dashboard.user_id">
                                <i class="fa fa-edit"></i> Edit
                            </router-link>

                            <router-link :to="`/dashboards/settings/subscribe/${dashboard.id}`"
                                class="btn btn-sm btn-default"
                                v-if="$store.state.user.user_id != dashboard.user_id">
                                <template v-if="dashboard.is_subscribed">
                                    <i class="fa fa-remove"></i> Unsubscribe
                                </template>
                                <template v-else>
                                    <i class="fa fa-star"></i> Subscribe
                                </template>
                            </router-link>
                        </div>
                    </div>
                    <div class="card-body">
                        <div class="row form-group mb-2">
                            <label class="col-lg-3 col-md-3 col-sm-4 text-sm-right">
                                Dashboard Name:
                            </label>
                            <div class="col-lg-6 col-md-6 col-sm-8">
                                {{ dashboard.dashboard_name }}
                            </div>
                        </div>
                        <div class="row form-group">
                            <label class="col-lg-3 col-md-3 col-sm-4 text-sm-right">
                                Global:  <i class="fa fa-question-circle" title="If you make this a Global Dashboard, other users will be able to subscribe and clone this."></i>
                            </label>
                            <div class="col-lg-6 col-md-6 col-sm-8">
                                <span class="badge badge-success" v-if="dashboard.is_global == 1">Yes</span>
                                <span class="badge badge-default" v-else>No</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div id="dashboard-rows" class="mb-4">
            <div class="card mb-3" v-for="(row,i) in rows">
                <div class="card-header">
                    Row {{ i+1 }}
                </div>

                <div class="card-body">
                    <div class="row">
                        <div v-for="(cell, j) in row.cells" :class="'col-md-'+cell.grid_size">
                            <div class="dash-cell">
                                <template v-if="cell.user_filter_id">
                                    <div class="text-muted">Cell Type: Saved Filter</div>
                                    {{ $root.getPrettyAssetName(cell.asset_type) }} - {{ cell.filter_name }}
                                    <div>
                                        Display Type: <span v-if="cell.display_type">{{ cell.display_type | capitalize }}</span> <span v-else>List</span>
                                    </div>
                                    <div v-if="cell.display_type === 'total' && cell.label_color && cell.min_highlight_count">
                                        <span :class="'badge badge-'+cell.label_color">If Total is >= {{ cell.min_highlight_count }}, Highlight This Color</span>
                                    </div>
                                </template>

                                <template v-else-if="cell.user_report_id">
                                    <div class="text-muted">Cell Type: Saved Report</div>
                                    {{ $root.getPrettyAssetName(cell.report_type) }} - {{ cell.report_name }}
                                </template>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="card mt-4">
            <div class="card-header">
                Subscribed Users ({{ users.length }})
            </div>
            <div class="card-body">
                <v-client-table :columns="columns" :options="options" :data="users">

                    <div slot="afterFilterWrapper" class="ml-md-2 ml-0 mt-md-0 mt-2 mb-md-0 mb-3 float-md-left">

                        <button type="button" class="btn btn-default ml-2" @click="subscribe_user = true;">
                            <i class="fa fa-plus-circle text-success"></i> Subscribe User
                        </button>
                    </div>

                    <button class="btn btn-sm btn-default" slot="UserId" slot-scope="props" @click="unsubscribeUser(props.row.UserId)">
                        <i class="fa fa-remove"></i> Unsubscribe
                    </button>

                    <template slot="LastName" slot-scope="props">
                        {{ props.row.LastName }}, {{ props.row.FirstName }}
                    </template>

                    <a :href="`mailto:${props.row.email}`" slot="email" slot-scope="props">
                        {{ props.row.email }}
                    </a>
                </v-client-table>
            </div>
        </div>

        <b-modal v-model="subscribe_user"
            ref="subscribeUser"
            :title="'Subscribe User to Dashboard: '+dashboard.dashboard_name"
            size="md"
            no-fade
            :no-close-on-backdrop="true"
            ok-variant="success"
            :ok-title="'Subscribe User'"
            @ok="subscribeUser">
            <div class="form-group">
                <label class="col-form-label" :class="{'text-danger': errors.user_id}">
                    Search Users: <i class="fa fa-asterisk text-danger small"></i>
                </label>
                <div class="">
                    <user-select @vuselected="setSubscribeNewUser" :hasError="errors.user_id ? true : false"></user-select>
                </div>
            </div>
        </b-modal>

        <b-modal v-model="remove_user"
            ref="unsubscribeUser"
            :title="'Unsubscribe User from Dashboard: '+this.dashboard.dashboard_name"
            size="md"
            no-fade
            :no-close-on-backdrop="true"
            ok-variant="warning"
            :ok-title="'Unsubscribe User'"
            @ok="subscribeUser">
            <div class="alert alert-warning">
                <strong>Warning:</strong> You are about to unsubscribe <strong>{{ subscriber.FirstName }} {{ subscriber.LastName }}</strong> from this Dashboard.
            </div>
        </b-modal>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                dashboard_id: this.$route.params.id,
                dashboard: {},
                rows: [],
                users: [],
                subscriber: {},
                subscribe_user: false,
                remove_user: false,
                errors: {},

                columns: [
                    'UserId',
                    'LastName',
                    'email',
                ],

                options: {
                    headings: {
                        UserId: 'Actions',
                        LastName: 'Last Name',
                        email: 'Email',
                    },
                    orderBy: {
                        ascending: true,
                        column: 'LastName',
                    },
                },
            }
        },

        watch: {

        },

        computed: {

        },

        methods: {

            getDashboard() {
                this.$http.get('/dashboards/settings/view/'+this.dashboard_id)
                .then(response => {
                    //SEt it
                    this.dashboard = response.data.dashboard;
                    this.rows = response.data.rows;
                    this.users = response.data.users;
                })
                .catch(err => {

                });
            },

            unsubscribeUser(user_id){
                //Find the user
                var user = null;

                //Loop
                for (var i = 0; i < this.users.length; i++)
                {
                    if(user_id == this.users[i].UserId)
                    {
                        user = this.users[i];
                    }
                }

                //Chec kfor null?
                if(!user)
                {
                    //Alert?
                }

                //SEt it
                this.subscriber = user;

                //Show Modal
                this.remove_user = true;
            },

            setSubscribeNewUser(user){
                if (!user)
                {
                    this.subscriber = {};
                }
                else
                {
                    this.subscriber = user;
                }
            },

            subscribeUser(bvEvt){
                //Stops the modal from closing
                bvEvt.preventDefault();

                //Check User
                if(!this.subscriber.UserId)
                {
                    //Alert
                    this.$toastr.warning('Select a User to Subscribe');

                    //Stop Here
                    return;
                }

                //Send it
                this.$http
                .post('dashboards/settings/subscribe/'+this.dashboard.id, {user_id: this.subscriber.UserId})
                .then(response => {
                    //Alert the user?
                    this.$toastr.success('User ' + (this.subscribe_user ? 'Subscribed' : 'Unsubscribed'));

                    //Push User Onto the Stack
                    if(this.subscribe_user)
                    {
                        //Push
                        this.users.push(this.subscriber);
                    }
                    else
                    {
                        //Splice
                        for (var i = 0; i < this.users.length; i++)
                        {
                            //Check it
                            if(this.subscriber.UserId == this.users[i].UserId)
                            {
                                this.users.splice(i, 1);
                            }
                        }
                    }

                    //Close the modal
                    this.subscribe_user = false;
                    this.remove_user = false;

                    //Reset
                    this.subscriber = {};
                })
                .catch(error => {
                    //Check for error
                    if(error.response.status === 422)
                    {
                        //Display validation errors
                        this.errors = error.response.data;
                    }
                });
            },
        },

        mounted() {
            this.getDashboard();
        }
    }
</script>

<style type="text/css" scoped>
    .dash-cell {
        text-align: center;
        background: #f5f5f5;
        border: 1px solid #eaeaea;
        padding: 20px;
    }
</style>